// CL-5 RESUME_MARKER dispatch integration (omo F-11 영감).
//
// CL-1 RESUME_MARKER 상수를 활용 — recovery 성공 후 LLM messages에 system message push.
// 효과: recovery 후 tool re-execution 방지 + LLM이 회복 인지.
//
// idempotent — 직전 message가 이미 RESUME_MARKER면 중복 push 안 함.
//
// 의존성: CL-1 dispatchRecovery + RESUME_MARKER

import { dispatchRecovery, RESUME_MARKER } from './RECOVERY_TABLE.js';

/**
 * messages 배열에 RESUME_MARKER system message push.
 * 원본 mutation 0 — 새 배열 반환.
 *
 * @param {Array<object>} messages
 * @returns {{messages: Array<object>, pushed: boolean}}
 */
export function pushResumeMarker(messages) {
  if (!Array.isArray(messages)) return { messages, pushed: false };
  if (_lastIsResumeMarker(messages)) return { messages, pushed: false };
  return {
    messages: [...messages, { role: 'system', content: RESUME_MARKER }],
    pushed: true,
  };
}

/**
 * dispatchRecovery 호출 후 success 시 RESUME_MARKER를 ctx.messages에 push (in-place).
 * caller 참조 보존 — 외부에서 ctx.messages 변수 그대로 사용 가능.
 *
 * @param {string} type
 * @param {object} ctx — ctx.messages 권장 (없거나 non-array면 marker push X)
 * @returns {Promise<{recovered: boolean, markerPushed: boolean}>}
 */
export async function dispatchRecoveryWithMarker(type, ctx) {
  const recovered = await dispatchRecovery(type, ctx);
  if (!recovered) return { recovered: false, markerPushed: false };
  if (!ctx || !Array.isArray(ctx.messages)) {
    return { recovered: true, markerPushed: false };
  }
  if (_lastIsResumeMarker(ctx.messages)) {
    return { recovered: true, markerPushed: false };
  }
  ctx.messages.push({ role: 'system', content: RESUME_MARKER });
  return { recovered: true, markerPushed: true };
}

function _lastIsResumeMarker(messages) {
  const last = messages[messages.length - 1];
  return !!(last && last.role === 'system' && last.content === RESUME_MARKER);
}

export const _lastIsResumeMarkerForTest = _lastIsResumeMarker;
